import React from 'react'
import { Link } from 'react-static'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import MenuBG from './MenuBG'
import { fadeIn, fadeOut } from '../../../animations'

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  background-color: ${props => props.theme.main.bg};
  opacity: 0;

  .home-menu-links {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column wrap;
  }

  a {
    font-size: 3em;
    color: #fff;
    text-shadow: 6px 6px 0 ${props => props.theme.secondary.bg3};
    transition: transform 0.2s ease, text-shadow 0.2s ease;
    text-decoration: none;
    padding: 0.3em;
    position: relative;
    z-index: 11;
    transform: translateY(0) skewY(-13deg);

    &:hover {
      transform: translateY(-0.1em) skewY(-13deg);
      color: #fff;
    }
  }

  @media screen and (min-width: 801px) {
    a {
      transform: translateY(0) skewY(0deg);
      text-shadow: 0 0 0 ${props => props.theme.secondary.bg3};

      &:hover {
        transform: translateY(-0.1em) skewY(0deg);
        text-shadow: 6px 6px 0 ${props => props.theme.secondary.bg3};
      }
    }

    .home-menu-links {
      height: 90%;
      transform: skewY(-13deg);
      flex-flow: row wrap;
    }
  }

  @media screen and (min-width: 801px) and (max-width: 1100px) {
    a {
      font-size: 2.6em;
    }
  }

  @media screen and (min-width: 1101px) {
    a {
      font-size: 3em;
    }
  }
`

class HomeMenu extends React.PureComponent {
  // static propTypes = {
  // 	latestSlug: PropTypes.string.isRequired
  // }

  componentWillEnter(cb) {
    fadeIn('.home-menu', 0.5, cb)
  }

  componentWillLeave(cb) {
    fadeOut('.home-menu', 0.5, cb)
  }

  render() {
    return (
      <Wrapper className="home-menu">
        <MenuBG />
        <div className="home-menu-links">
          {/* <Link to={`/latest/${this.props.latestSlug}`}>Latest</Link> */}
          <Link to="/gallery/overview">Gallery</Link>
          <Link to="/people/bevan">People</Link>
          <Link to="/about">About</Link>
          <Link to="/contact">Contact</Link>
        </div>
      </Wrapper>
    )
  }
}

export default HomeMenu



// WEBPACK FOOTER //
// /opt/build/repo/src/components/common/menuModal/Menu.js